module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/products-engagement.json
// module id = 505
// module chunks = 227550415020864